import React from 'react';
import Title from "../components/Title/Title";
import AccountAside from "../components/AccountAside";
import AccountGeneral from "../components/AccountGeneral";

const AccountGeneralPage = () => {
  return (
    <>

      <AccountGeneral/>
{/*Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, porro!*/}
    </>
  );
};

export default AccountGeneralPage;